
//Description: this helper prevents letters from being typed in the input where it is used

const InputNumbers = (event) => {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
}

export default InputNumbers;